import React, { useState } from 'react';
import { usePopper } from 'react-popper';
import ReactDOM from 'react-dom';
import cn from 'classnames';
import { Placement } from '@popperjs/core';

interface ITooltip {
  label: string;
  placement?: Placement;
  className?: string;
}

export const Tooltip: React.FC<ITooltip> = ({
  children,
  label,
  placement = 'top',
  className,
}) => {
  const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(
    null,
  );
  const [popperElement, setPopperElement] = useState<HTMLElement | null>(null);
  const [isShown, setIsShown] = useState(false);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement,
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 8],
        },
      },
    ],
  });

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        ref: setReferenceElement,
        onMouseEnter: () => setIsShown(true),
        onMouseLeave: () => setIsShown(false),
      } as React.HTMLAttributes<typeof child>);
    }
    return child;
  });

  return (
    <>
      {childrenWithProps}

      {isShown &&
        ReactDOM.createPortal(
          <div
            ref={setPopperElement}
            style={styles.popper}
            {...attributes.popper}
            className={cn(
              'z-10 select-none rounded bg-gray-50 px-2 py-1 text-xs text-gray-800',
              className,
            )}
          >
            {label}
          </div>,
          document.querySelector('body')!,
        )}
    </>
  );
};
